import { arrayOf, bool, shape, string } from "prop-types";
import { SubLineItemShape } from "shared/components/configurator/roomBook.shape";
import { OptionShape } from "shared/shapes/subLineItemOption.shape";
import { ConfiguratorLineItemShape } from "shared/shapes/configuratorLineItem.shape";

export const ConfiguratorSubLineItemShape = shape({
  ...SubLineItemShape,
  lineItem: ConfiguratorLineItemShape,
  isOptional: bool,
  isReplaced: bool,
  isReplacement: bool,
  isActivated: bool,
  isRequired: bool,
  atLeastOneWithMapping: bool,
  status: shape({
    id: string,
    label: string,
    color: string,
    selectable: bool
  }),
  options: arrayOf(OptionShape),
  selectedOption: OptionShape,
  key: string
});

export default ConfiguratorSubLineItemShape;
